// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-below-or';

export const Component = () => (
  <path d='M23.563 1v9.818h.958V1h-.958ZM18.63 1v9.818h1.006V1H18.63Zm.288 17.72-3.927-3.975.718-.67 4.407 4.359.67.766-5.077 5.077-.718-.67 3.927-3.976H0v-.91h18.918Z' />
);

export const viewBox = '0 0 25 25';
